<template>
   <b-modal
    @shown="showEmbeddedPage"
    @hide="hidenbe"
    id="nbeModal"
    ref="nbe"
    size="m"
    centered
    :header-class="{'ltr' : lang==2 , 'rtl' : lang==1}"
    >
          <div class='nbe-content-wrapper'>    
            <div id="nbeContent">
             
            </div>
          </div>
      </b-modal>
</template>

<script>
export default {
  data() {
      return {
      }
    },
  props: ['lang'],
  watch:{
  },
  methods: {
     hidenbe(){
        this.$router.replace({query: {status:0,message:'Request Cancelled'} });
  },
  showEmbeddedPage(){
       Checkout.showEmbeddedPage('#nbeContent');
  }
  },

}

</script>
<style >

/* note : IMPO don't change id of modal */
#nbeModal___BV_modal_content_ {
  margin: auto;
  height: 90vh;
  max-width: 430px;
}
#nbeModal___BV_modal_header_{
  height: 38px;
  border: none;
  padding: 0;
  margin: 0;
}
#nbeModal___BV_modal_header_ button{
  background: transparent;
  margin: 0;
  color: grey;
  margin: 0px 5px;
  font-size: 25px;
}
#nbeModal___BV_modal_body_{
    padding: 5px;
    padding-top: 0;
    padding-bottom: 10px;
    overflow: auto;
}

#nbeModal___BV_modal_body_ .nbe-content-wrapper #nbeContent{
  padding:10px;
  padding-top:0px;
  overflow: unset !important;
}
#nbeModal___BV_modal_footer_{
  display: none;
}
</style>